import { Component, Input } from '@angular/core';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'ph-loader',
    templateUrl: './ph-loader.component.html',
    styleUrls: ['./ph-loader.component.scss'],
	imports: [PhIconComponent],
    standalone: true
})

export class PhLoaderComponent {
	@Input() size: number = 200;
}